/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".canvas-container[_ngcontent-%COMP%]{display:block;margin:0 auto}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/components/doughnut-chart/doughnut-chart.component.scss.shim.ngstyle.js.pre-build-optimizer.js